import Wrapper from "@/views/Index"
import Home from "@/views/Home"
import NotFound from "@/views/NotFound"
import BeretPrepare from "@/views/Beret/Prepare"
import BeretPlay from "@/views/Beret/Play"
import LoupsGarousPrepare from "@/views/LoupsGarous/Prepare"
import LoupsGarousPlay from "@/views/LoupsGarous/Play"
import LoveLetterPrepare from "@/views/LoveLetter/Prepare"
import LoveLetterLobby from "@/views/LoveLetter/Lobby"
import LoveLetterPlay from "@/views/LoveLetter/Play"

export default [
    { path: "/", component: Wrapper, children: [
        { path: "", name: "home", component: Home },
        { path: "beret/prepare", name: "beret-prepare", component: BeretPrepare },
        { path: "beret/play", name: "beret-play", component: BeretPlay },
        { path: "loups-garous/prepare", name: "loups-garous-prepare", component: LoupsGarousPrepare },
        { path: "loups-garous/play", name: "loups-garous-play", component: LoupsGarousPlay },
        { path: "love-letter/prepare", name: "love-letter-prepare", component: LoveLetterPrepare },
        { path: "love-letter/lobby", name: "love-letter-lobby", component: LoveLetterLobby },
        { path: "love-letter/play", name: "love-letter-play", component: LoveLetterPlay }
    ]},
    { path: "*", name: "not-found", component: NotFound }
]